module.exports = __webpack_public_path__ + "static/media/ic_play.e363df4b.svg";